/**
 * PDP: swaps the "free gifts" (additional_services) block and the
 * "additional info" block once BOTH have appeared in the DOM.
 *
 * Targets:
 *   - [data-free-gifts]      (snippets/product-info-vertical.liquid, additional_services)
 *   - [data-additional-info] (snippets/product-info-vertical.liquid, additional_info)
 *
 * The two nodes are siblings inside [data-product-info-vertical]. We wait via a
 * MutationObserver (Alpine/section content can render late), then swap them once.
 *
 * Runs only when window.pdpBlocksSwap === true (A/B test flag).
 */
(function () {
  'use strict';

  var SWAPPED_ATTR = 'data-block-swapped';

  /** Safely swaps two nodes' positions, even when they are adjacent. */
  function swapNodes(a, b) {
    if (a === b || !a.parentNode || !b.parentNode) return;
    var placeholder = document.createComment('swap');
    a.parentNode.insertBefore(placeholder, a);
    b.parentNode.insertBefore(a, b);
    placeholder.parentNode.insertBefore(b, placeholder);
    placeholder.parentNode.removeChild(placeholder);
  }

  /** Swaps the pair inside a single product-info container. Returns true if done. */
  function trySwap(container) {
    if (container.hasAttribute(SWAPPED_ATTR)) return true;

    var freeGifts = container.querySelector('[data-free-gifts]');
    var additionalInfo = container.querySelector('[data-additional-info]');

    if (!freeGifts || !additionalInfo) return false;

    swapNodes(freeGifts, additionalInfo);
    container.setAttribute(SWAPPED_ATTR, 'true');
    return true;
  }

  function init() {
    if (window.pdpBlocksSwap !== true) return;

    var containers = document.querySelectorAll('[data-product-info-vertical]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      // Already present? Swap right away.
      if (trySwap(container)) return;

      // Otherwise wait for both elements to show up.
      var observer = new MutationObserver(function () {
        if (trySwap(container)) observer.disconnect();
      });

      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
